<script lang="ts">
    import { check_emotion_values } from "./lib/llm/check_emotion";

    let emotionInput = $state<string>("");
    let emotionResult = $state<string>("");

    let output = $state("");
    let input = $state("");

    function handleSubmit() {
        output += input + "\n";
        input = "";
    }
</script>

<div class="app">
    <div class="content">
        <main class="main-content" style="background-color: transparent;">
            <img src="img/title-text.png" alt="Interrogation" class="title-img" />
            <p></p>

            <!-- old link to game.html-->
            <!--
            <a href="game.html">Go to Game</a>
            -->
            <!-- new button to game.html-->

            <button
                class="start-button"
                onclick={() => {
                    window.location.href = "game.html";
                }}
            >
                <img src="img/start_button.png" alt="Start button" />
            </button>
        </main>
        <div class="bottom">
            <div class="output">{output}</div>
            <input
                id="test-input"
                bind:value={input}
                onkeydown={(e) => e.key === "Enter" && handleSubmit()}
                placeholder="Type here..."
            />
            <button onclick={handleSubmit}>Send</button>
            <div style="margin-top:2em">
                <input
                    id="emotion-input"
                    type="text"
                    placeholder="Type text to test emotion"
                    style="width:70%"
                    bind:value={emotionInput}
                />
                <p>is this visible?</p>
                <button
                    id="test-emotion-btn"
                    onclick={async () => {
                        try {
                            emotionResult = "Loading...";
                            const res = await check_emotion_values(emotionInput);
                            if (res) {
                                emotionResult = JSON.stringify(res, null, 2);
                            } else {
                                emotionResult = "No result";
                            }
                        } catch (e) {
                            emotionResult = `Error: ${e instanceof Error ? e.message : String(e)}`;
                        }
                    }}>Test Emotion</button
                >
                <pre id="emotion-result" style="margin-top:1em">{emotionResult}</pre>
            </div>
        </div>
    </div>

    <style lang="css">
        .app {
            display: flex;
            height: 100vh;
            width: 100vh;
            background-color: transparent;
            color: #ffffff;
        }

        .content {
            flex: 1;
            width: 100%;
            display: flex;
            flex-direction: column;
            background-color: transparent;
        }

        .main-content {
            flex: 0.5;
            padding: 1rem;
            background-color: transparent;
            max-height: calc(90vh - 200px);
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            gap: 2rem;
            justify-content: flex-start;
            align-items: center;
        }

        .main-content h1 {
            font-size: 4em;
            margin: 0;
        }

        .bottom {
            display: flex;
            flex-direction: column;
            height: 120px;
            border-top: 1px solid #333;
            background-color: transparent;
        }

        .output {
            flex: 0;
            padding: 0.5rem;
            background-color: #1e1e1e;
            overflow-y: auto;
            white-space: pre-wrap;
            color: #ffffff;
            display: none;
        }

        input {
            padding: 0.5rem;
            border: 1px solid #555;
            background-color: #2a2a2a;
            color: #ffffff;
        }

        input::placeholder {
            color: #cccccc;
        }

        button {
            padding: 0.2em 0.4em;
            font-size: 0.75em;
            background-color: #646cff;
            color: white;
            border: none;
            cursor: pointer;
        }

        button:hover {
            background-color: #535bf2;
        }

        .start-button {
            background-color: transparent;
            border: none;
            padding: 0;
            cursor: pointer;
        }

        .start-button:hover {
            background-color: transparent;
            filter: brightness(1.3);
        }

        .start-button img {
            display: block;
        }
        .title-img {
            width: 80%;
            max-width: 800px;
            height: auto;
            display: block;
            margin: 1rem 0;
        }
        @media (max-width: 768px) {
            .sidebar {
                width: 60px;
            }

            .sidebar-item {
                font-size: 1.2rem;
            }

            .bottom {
                height: 150px;
            }

            .main-content {
                padding: 0.5rem;
            }
        }

        @media (max-width: 480px) {
            .sidebar {
                width: 50px;
            }

            .sidebar-item {
                font-size: 1rem;
                margin: 0.5rem 0;
            }

            .bottom {
                height: 120px;
            }
        }
    </style>
</div>
